$ = require 'jquery'
Alerts = require 'views/lib/alerts'
ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
Backgrounds = require 'data/backgrounds'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
Controller = require 'controller'
CreateOrgView = require 'views/organization/create-org-view'
Language = require 'lib/language'
lastOrganization = require('common/lib/util/last-organization').default
ModelLoader = require 'db/model-loader'
NewBoardHelperAddOrgView = require 'views/board/new-board-helper-add-org-view'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
Storage = require 'lib/storage'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
l = require 'lib/localize'
boardMenuVisTemplate = require 'views/templates/board_menu_vis'
{ getOrgBoardLimits } = require 'views/board-create/helpers'

LastOrganization = lastOrganization Storage

module.exports = class CopyBoardView extends View
  viewTitleKey: 'copy board'

  events:
    'change select[name="org-id"]': 'changeOrg'
    'click .js-helper-add-org': 'helperAddOrg'
    'submit form': 'submit'
    'click .js-submit': 'submit'
    'click .js-create-org': 'newOrg'
    'click .js-change-vis': 'openChangeVis'
    'click .js-select': 'selectVis'
    'click .js-upgrade-link': 'trackUpgradeClick'

  getOrganization: ->
    switch @model.typeName
      when 'Organization'
        @model
      when 'Board'
        @model.getOrganization()
      when 'Member'
        null

  getDefaultIdOrganization: (idOrgs) ->
    if idOrgs.length == 0
      return null

    if @options.useLastOrganization
      if idOrgs.length == 1
        return idOrgs[0]

      idLastOrganization = LastOrganization.get()
      if idLastOrganization == LastOrganization.NO_ORGANIZATION
        null
      else if idLastOrganization? && idLastOrganization in idOrgs
        idLastOrganization
      else
        # Use the most recently created org
        idOrganization = null
        for id in idOrgs when !idOrganization? || id > idOrganization
          idOrganization = id
        idOrganization
    else
      if (idOrganization = @getOrganization()?.id)?
        idOrganization
      else
        null

  render: ->
    me = Auth.me()

    idOrganization = @getDefaultIdOrganization(me.organizationList.pluck('id'))

    orgs = me.organizationList.map (org) ->
      _.extend org.toJSON(), {
        selectOrg: org.id == idOrganization
      }

    hasOrg = idOrganization?

    data = {
      orgs
      hasOrg
      upgradeUrl: if hasOrg then @getOrgBillingUrl(idOrganization) else '#'
      canAddToOrgs: orgs.length != 0
      willRemovePowerUps: @model.powerUpsCount() > me.getPowerUpsLimit()
    }

    # Yes, this is implicit coupling to the number of placeholders
    # we have in the strings file. If we ever have another nondeterministic
    # string, we can think about doing this more formally...
    placeholderKey = Math.floor(Math.random() * 13).toString()
    data.placeholder = l(['board name placeholder', placeholderKey])

    if @options.term
      data.name = @options.term

    data.pLevel = 'private'
    if @model.owned()
      data.pLevel = @model.get('prefs').permissionLevel
    else if hasOrg
      data.pLevel = 'org'

    if @options?.newOrgBoard
      data.hideOrg = true

    @$el.html(
      templates.fill(
        'board_copy',
        data
      )
    )

    @checkBoardPermissions()

    @

  getOrgBillingUrl: (orgId) ->
    return "/#{@modelCache.get('Organization', orgId).get('name')}/billing"

  checkBoardPermissions: ->
    orgId = @$('select[name="org-id"]').val()
    if !orgId
      @renderBoardVisChooser()
      return

    getOrgBoardLimits(orgId)
    .then (boardLimitData) =>
      if boardLimitData.enabled
        @$('.js-boards-limit-upgrade-ad').removeClass('hide')
        @disableSubmit()
      else
        @renderBoardVisChooser()

  renderBoardVisChooser: (selectedVis) ->
    @$('.js-permissions').removeClass('hide')
    orgId = @$('select[name="org-id"]').val()

    visData =
      isNewBoard: true
      canChange: true

    @disableSubmit()

    Promise.try =>
      localizedParagraph = (key) -> "<p>#{l(key)}</p>"
      @$('.js-vis-display').html localizedParagraph('checking visibility permissions')

      if orgId
        org = @modelCache.get('Organization', orgId)

        if org? && org.get('memberships')? && org.get('products')? && org?.isFeatureEnabled('restrictVis')
          org
        else
          ModelLoader.loadOrganizationMinimal orgId

    .then (org) =>
      if org?
        if !@canChangeOrg(org, selectedVis)
          selectedVis = null

        _.extend visData,
          hasOrg: true
          orgName: org.get('displayName')
          hasSuperAdmins: org.isFeatureEnabled('superAdmins')
          privateRestricted: !@canChangeOrg(org, 'private')
          orgRestricted: !@canChangeOrg(org, 'org')
          publicRestricted: !@canChangeOrg(org, 'public')

      defaultVis =
        if org? && @canChangeOrg(org, 'org')
          if @model.isPrivate()
            'private'
          else
            'org'
        else
          'private'
      visData.current = selectedVis ? defaultVis

      { org, visData }

    .then ({ org, visData }) =>
      currentLevel = visData.current

      @setPermissionLevel(currentLevel)
      @$('.js-vis-chooser').html(boardMenuVisTemplate(visData))

      @$('.js-vis-display').html templates.fill 'board_copy_vis',
        visIconClass: BoardDisplayHelpers.getPermLevelIconClass(currentLevel)
        visDisplayText: l(['board perms', currentLevel, 'name'])

      # It's possible that there's no valid permission level for us, in which
      # case we can't create a board at all
      if org? && visData.privateRestricted && visData.orgRestricted && visData.publicRestricted
        $noValidPrivs = @$('.js-no-valid-org-privs')
        if org.owned()
          $noValidPrivs.html l('board create restriction admin', { urlSettings: "/#{ org.get('name') }/account" })
        else
          $noValidPrivs.html l('board create restriction not admin')
        $noValidPrivs.removeClass('hide')
        @$('.js-vis-chooser,.js-vis-display').addClass('hide')
      else
        @enableSubmit()
    .done()

    @

  enableSubmit: ->
    @$('.js-submit').removeClass('disabled')

  disableSubmit: ->
    @$('.js-submit').addClass('disabled')

  resetVisChooser: ->
    @$('.js-no-valid-org-privs').addClass('hide')
    return

  openChangeVis: (e) ->
    Util.stop(e)
    @$('.js-vis-display').addClass('hide')
    @$('.js-vis-chooser').removeClass('hide')

    return

  selectVis: (e) ->
    Util.stop(e)

    $target = $(e.target).closest('.js-select')
    if $target.hasClass('disabled')
      return

    @$('.js-vis-display').removeClass('hide')
    @$('.js-vis-chooser').addClass('hide')

    vis = $target.attr('name')
    @renderBoardVisChooser(vis)

    track("New Board", "Change Visibility", vis)

    return

  setPermissionLevel: (permissionLevel) ->
    @$('input[name="permissionLevel"]').val(permissionLevel)

  getPermissionLevel: ->
    @$('input[name="permissionLevel"]').val() ? ""

  canChangeOrg: (org, setting) ->
    org.canSetVisibility setting


  allowBoardCopy: ->
    @$('.js-boards-limit-upgrade-ad').addClass('hide')
    @resetVisChooser()
    @$('.js-vis-display').removeClass('hide')
    @$('.js-vis-chooser').addClass('hide')
    @renderBoardVisChooser()

  changeOrg: (e) ->
    track("New Board", "Change Org")
    orgId = e.target.value

    # personal boards have no restrictions
    if !orgId
      @allowBoardCopy()
      return

    @disableSubmit()
    getOrgBoardLimits(orgId)
    .then (boardLimitData) =>
      if boardLimitData.enabled
        trackUe('board limits', 'shows', 'upgrade ad', '', '', 'by selecting a team in copy board', { teamId: orgId })
        @$('.js-permissions').addClass('hide')
        @$('.js-boards-limit-upgrade-ad').removeClass('hide')
        @$('.js-upgrade-link').attr('href', @getOrgBillingUrl(orgId))
      else
        @allowBoardCopy()

  helperAddOrg: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: new NewBoardHelperAddOrgView({ @model, @modelCache })
    track("New Board", "Open Add Org Helper")
    return

  defaultBackgroundColor: ->
    if Language.is('en')
      now = new Date()
      month = now.getMonth()
      date = now.getDate()

      if month == 2 && date == 17
        # It's March 17th, St. Patricks Day
        return 'green'

    'blue'

  submit: (e) ->
    Util.stop(e)

    return if @$('.js-submit').hasClass('disabled')

    # Figure out the name they want, and abort if it's blank
    $name = @$('input[name="name"]')
    name = $name.val().trim()
    if name == ''
      $name.focus().select()
      return

    idOrganization = @$('select[name="org-id"]').val() ? ""

    LastOrganization.set(idOrganization)

    # Data that we'll use in the body of the POST to create the board
    initialData =
      name: name
      idOrganization: idOrganization

    permissionLevel = @$('input[name="permissionLevel"]').val()

    backgroundColor = @defaultBackgroundColor()

    ownedBoards = _.filter Auth.me().boardList.models, (board) -> board.owned()

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: permissionLevel
    }, initialData)

    requestData.idBoardSource = @model.id
    requestData.keepFromSource =
      @$('input:checkbox:checked').map(-> this.name).get().join()

    track("New Board", "Copy")

    newBoard = Auth.me().boardList.create initialData, {
      @modelCache
      requestData: requestData
      success: (board) =>
        Alerts.hide('copying')

        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # We have to wait until we the board id back before we can
        # display the board
        Controller.displayBoard({
          idBoard: board.id
        }).done()

        return
      error: ->
        Alerts.flash('could not create board', 'error', 'create error')
    }

    Alerts.show('copying', 'info', 'copying')

    PopOver.hide()

  newOrg: (e) ->
    trackingOpts = { category: 'board', method: 'by clicking create team in copy board menu' }
    Util.stop(e)
    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, trackingOpts })
    track("New Board", "Open Create Org")
    return

  trackUpgradeClick: ->
    trackUe('board limits', 'clicks', 'upgrade button', 'copy board upgrade ad', '', '', { teamId: @$('select[name="org-id"]').val() })


// WEBPACK FOOTER //
// ./app/scripts/views/board/copy-board-view.coffee